var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex flex-row align-items-center"},[_c('img',{attrs:{"src":require(`@/assets/img/flags/${_vm.myflagData}`)}}),_c('span',{class:['ml-2', _vm.teamDataClass]},[_vm._v(" "+_vm._s(_vm.teamData)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }